module.exports = __webpack_public_path__ + "img/69.555d9c7a.png";